import { render } from "./TodayProduction.vue?vue&type=template&id=2c00dc50&scoped=true&ts=true"
import script from "./TodayProduction.vue?vue&type=script&lang=ts"
export * from "./TodayProduction.vue?vue&type=script&lang=ts"

import "./TodayProduction.vue?vue&type=style&index=0&id=2c00dc50&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c00dc50"]])

export default __exports__